import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess, fetchProfile } from './redux/user/actions.js';
import { fetchChats } from './redux/chat/actions.js';

const Initializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const user_id = localStorage.getItem('user_id');

    if (user_id) {
      dispatch(loginSuccess(user_id));
      dispatch(fetchProfile(user_id));
      dispatch(fetchChats(user_id));
    }
  }, [dispatch]);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-mode');
    }
  }, []);

  return (
    <>
      {children}
    </>
  );
};

export default Initializer;